import { Modal } from 'components'
import { ReactElement, ReactNode, useState } from 'react'
import { Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'

interface Props {
  onConfirm(): void
  children?: ReactNode
  confirmationButtonText?: string
}

const modalDescription = {
  fontSize: 22,
  fontWeight: 'bold',
  maxWidth: 380,
  color: (theme: Theme) => theme.palette.text.secondary,
}

export const useDeleteModal = ({
  onConfirm,
  children,
  confirmationButtonText,
}: Props): [ReactElement, VoidFunction] => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleConfirm = () => {
    onConfirm()
    setIsOpen(false)
  }

  return [
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Attention!"
      onConfirm={handleConfirm}
      onConfirmButtonText={confirmationButtonText || 'Ok'}
    >
      <Typography sx={modalDescription}>{children}</Typography>
    </Modal>,
    () => setIsOpen(!isOpen),
  ]
}
